import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
export var ContentModuleSegment = /*#__PURE__*/ styled("div", {
    target: "eo9003m0"
})("margin-bottom:", function(param) {
    var bottomMargin = param.bottomMargin, theme = param.theme;
    return bottomMargin === "small" ? theme.spacing[30] : theme.spacing[120];
}, ";", Theme.mq("sm"), "{margin-bottom:", function(param) {
    var bottomMargin = param.bottomMargin, theme = param.theme;
    return bottomMargin === "small" ? theme.spacing[40] : theme.spacing[140];
}, ";}&:last-child{margin-bottom:0;}");
